<script lang="ts">
	export let headers = []
</script>

<thead class="border-b-2">
	<tr class="font-semibold text-center">
		{#each headers as h}
			{#if h.placeholderType === 'image'}
				<td class="placeholder--image" style={h.style.join(' ')}>
					{h.label}
				</td>
			{:else}
				<td style={h.style.join(' ')}>
					{h.label}
				</td>
			{/if}
		{/each}
	</tr>
</thead>

<style lang="postcss">
	.placeholder--image {
		width: 200px;
		height: 60px;
	}
</style>